/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiCountryFromJSON, StreemApiCountryToJSON, } from './';
export function StreemApiGetCountriesResponseFromJSON(json) {
    return StreemApiGetCountriesResponseFromJSONTyped(json, false);
}
export function StreemApiGetCountriesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'countries': !exists(json, 'countries') ? undefined : (json['countries'].map(StreemApiCountryFromJSON)),
    };
}
export function StreemApiGetCountriesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'countries': value.countries === undefined ? undefined : (value.countries.map(StreemApiCountryToJSON)),
    };
}
//# sourceMappingURL=StreemApiGetCountriesResponse.js.map